<template>
    <div id="app">
        <Cookies v-if="showCookiesNotice" v-show="showCookiesNotice" @closeCookieNotice="showCookiesNotice = false" />

        <router-view :cookiesAccepted="cookiesAccepted"/>
    </div>
</template>

<script>
	import Cookies from "./components/Cookies";

	export default {
		components: {Cookies},
		data() {
			return {
				showCookiesNotice: !this.$cookie.get('cookies'),
                cookiesAccepted: this.$cookie.get('cookies') === 'accepted',
			}
		},
        watch: {
			showCookiesNotice: function () {
				this.cookiesAccepted = this.$cookie.get('cookies') === 'accepted';
            },
        },
	}
</script>

<style lang="scss">
    #app {
        font-family: 'Poppins', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>